module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('table', {
    staticClass: "table table-striped table-bordered table-condensed"
  }, [(_vm.headers) ? _c('thead', [_c('tr', [_c('th', {
    staticClass: "Center_content",
    staticStyle: {
      "width": "100px"
    }
  }, [_vm._v(_vm._s(_vm.headers[0]))]), _vm._v(" "), _c('th', {
    staticClass: "Center_content text_overflow"
  }, [_vm._v(_vm._s(_vm.headers[1]))])])]) : _vm._e(), _vm._v(" "), _c('tbody', [_vm._l((_vm.rows), function(row) {
    return [_c('tr', {
      staticStyle: {
        "background-color": "#fff"
      }
    }, [_c('td', {
      staticClass: "Center_content",
      staticStyle: {
        "width": "100px"
      }
    }, [(row.children) ? _c('span', {
      staticClass: "details details-close",
      on: {
        "click": function($event) {
          return _vm.communityDetails($event)
        }
      }
    }) : _vm._e()]), _vm._v(" "), _c('td', [_vm._v(_vm._s(row.description))])]), _vm._v(" "), _c('tr', {
      staticStyle: {
        "display": "none"
      }
    }, [(row.children) ? _c('td', {
      attrs: {
        "colspan": "2"
      }
    }, [_c('tree-table', {
      attrs: {
        "rows": row.children
      }
    })], 1) : _vm._e()])]
  })], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-63e9b9d8!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/fragment/TreeTable.vue
// module id = 307
// module chunks = 2 3